import { UserCheck, Radar, Headphones, Truck, Globe2, Zap } from "lucide-react";

const PILLARS = [
  {
    icon: UserCheck,
    title: "Dedicated Account Managers",
    desc: "One point of contact who owns your freight from quote to delivery — no call-center handoffs.",
  },
  {
    icon: Radar,
    title: "Real-Time Shipment Tracking",
    desc: "Live GPS updates and proactive delay alerts so you're never the last to know.",
  },
  {
    icon: Headphones,
    title: "24 / 7 Dispatch Support",
    desc: "A real human picks up the phone at 2 AM. No bots, no voicemail, no waiting.",
  },
  {
    icon: Truck,
    title: "Reliable Carrier Network",
    desc: "500+ vetted carriers across LTL, FTL, flatbed, and specialized — matched to your load.",
  },
  {
    icon: Globe2,
    title: "Cross-Border Expertise",
    desc: "Canada / USA customs, PARS / PAPS, ACE / ACI — handled in-house so freight keeps moving.",
  },
  {
    icon: Zap,
    title: "Fast Response Times",
    desc: "Quotes back the same business day. Urgent loads dispatched in under 60 minutes.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-us"
      className="relative bg-[#f7f6f3] py-16 sm:py-20 lg:py-24 border-t border-neutral-200"
    >
      <div className="container-mdgx">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="block w-8 h-px bg-[#D9633F]" />
            <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#D9633F]">Why Choose Midemide</span>
            <span className="block w-8 h-px bg-[#D9633F]" />
          </div>
          <h2 className="font-display font-extrabold text-neutral-900 text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]">
            Why businesses choose <span className="text-[#D9633F]">Midemide Logistics</span>.
          </h2>
          <p className="text-neutral-600 mt-5 leading-relaxed">
            Six reasons our partners stay with us — and refer us — across Canada and the United States.
          </p>
        </div>

        {/* 6-pillar grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-200 border border-neutral-200">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`pillar-${p.title.toLowerCase().split(" ")[0]}`}
                className="bg-white p-7 lg:p-8 flex flex-col items-start group hover:bg-[#fffaf6] transition-colors"
              >
                <div className="w-14 h-14 bg-[#D9633F]/10 border-2 border-[#D9633F]/30 flex items-center justify-center mb-5 group-hover:bg-[#D9633F] group-hover:border-[#D9633F] transition-colors">
                  <Icon size={22} className="text-[#D9633F] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display font-bold text-neutral-900 text-lg sm:text-xl leading-tight mb-3">
                  {p.title}
                </h3>
                <p className="text-neutral-600 text-sm leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
